<template>
  <div class="quick-nav">
    <!-- Administrator Canvate -->
    <div v-if="showHomeGrid && accountMetaLoaded">
      <div class="wrapper">
        <!-- <div class="toptitle">
          <div class="container">
            <h1>Patient Management</h1>
          </div>
        </div> -->
        <div v-if="isMobile()" class="mobile-form-section">
          <div class="mobile-form-group">
            <button
              v-for="tabDef in visibleTabs"
              :key="tabDef.key"
              class="mobile-form-btn"
              @click="activeTab = tabDef.key"
            >
              {{ tabDef.label }}
            </button>
            <home-grid :tab="activeTab" />
          </div>
        </div>
        <div v-else class="tabs col-sm-12 col-md-12 col-lg-12">
          <div
            v-for="tabDef in visibleTabs"
            :key="tabDef.key"
            :class="[tabDef.tabClass, { active: activeTab === tabDef.key }]"
            :style="{ display: 'block' }"
          >
            <a
              href="#/welcome"
              :id="tabDef.id"
              :title="tabDef.label"
              @click="activeTab = tabDef.key"
              >{{ tabDef.label }}</a
            >
          </div>
        </div>
        <home-grid v-if="!isMobile()" :tab="activeTab" />
      </div>
    </div>
    <div v-else-if="accountMetaLoaded">
      <welcome-health-records />
    </div>
  </div>
</template>

<script>
import { CURR_API } from "@/constants/apis";
import axios from "axios";
import OrderPopup from "@/components/private-layouts/OrderPopup.vue";
import NotePopup from "@/components/private-layouts/NotePopup.vue";
import HomeGrid from "./HomeGrid.vue";
import WelcomeHealthRecords from "./WelcomeHealthRecords.vue";
import WelcomeQuickNavSearch from "./WelcomeQuickNavSearch";
// import $ from "jquery";
import RelationsListDropdown from "@/components/includes/relations/RelationsListDropdown";
import { mapGetters } from "vuex";
// import {
//   summaryByExternalId,
//   acquireByExternalId,
//   provAssignmentById,
//   enterPatientChart,
// } from "@/api/sessionApi";
// import { getLatestTime } from "@/api/dataApi";
// import { getPreferences, updatePreferences } from "@/api/userApi";

import Pagination from "@/components/includes/pagination/Pagination";
import PaginationInfo from "@/components/includes/pagination/PaginationInfo";
import AccountNurseBio from "../welcome/AccountNurseBio";
import _ from "lodash";
//import PrimeVue from 'primevue/config';
//import PickList from 'primevue/picklist';
//import 'primevue/resources/themes/lara-light-indigo/theme.css';
//import 'primevue/resources/primevue.min.css';
//import 'primeicons/primeicons.css';

export default {
  name: "WelcomeQuickNav",
  data() {
    return {
      assignmentId: null,
      shareId: "",
      allProvs: null,
      activeTab: "Patient", // Switch that focuses on right tab;
      patients: [],
      nursesPL: null,
      PListPatientName: null,
      nurses: [],
      nurseassigned: [],
      nursename: "",
      patId: "",
      accountId: "",
      contents: [
        [
          {
            id: 341,
            order_id: 1,
            name: "susan",
            information: "inf context",
          },
          {
            id: 453,
            order_id: 2,
            name: "jack",
            information: "info context",
          },
        ],
        [],
      ],
      latestTimes: {},
      loading: true,
      filtered: true,
      filterList: [],
      itemsPerPage: 10,
      preferences: {},
      orderNum: null,
      noteTime: "",
      accounttype: "",
      accountMetaLoaded: false,
      orgStaffGroups: {
        providers: false,
        nurses: false,
        aids: false,
        alliedPros: false,
        // Shown as HomeGrid tab when org has a Geriatric Care Managers group.
        gcm: false,
      },
    };
  },
  props: {
    provider: Object,
  },
  watch: {
    visibleTabs(tabs) {
      if (!tabs.length) return;
      if (!tabs.some((t) => t.key === this.activeTab)) {
        this.activeTab = tabs[0].key;
      }
    },
    // filtered() {
    //   this.paginate(1);
    // },
    // filterList(newList) {
    //   let i;
    //   for (i = 0; i < this.patients.length; i++) {
    //     this.patients[i].active = !_.includes(newList, this.patients[i].id)
    //       ? "Active"
    //       : "Invacive";
    //   }
    // },
  },
  components: {
    // "quick-nav-search": WelcomeQuickNavSearch,
    // "relations-list-dropdown": RelationsListDropdown,
    "welcome-health-records": WelcomeHealthRecords,
    // "order-popup": OrderPopup,
    // "note-popup": NotePopup,
    // "account-nurse-bio": AccountNurseBio,
    "home-grid": HomeGrid,
    // Pagination,
    // PaginationInfo,
  },

  async mounted() {
    await this.loadWelcomeGridMeta();
  },
  // async mounted() {
  //   let that = this;
  //   getPreferences().then((data) => {
  //     that.$set(that, "preferences", data);
  //     let paginate = that.filterList === null;
  //     that.$set(that, "filterList", data.provider_filter);
  //     that.paginate(1);
  //   });
  //   this.paginate(1);

  //   let res = await getLatestTime({});
  //   res.forEach((upload) => {
  //     that.$set(that.latestTimes, upload.who, upload.when);
  //   });
  //   this.loading = false;
  //   // this.showNurseModule(1);
  // },
  computed: {
    ...mapGetters("login", {
      allData: "getAllData",
    }),
    // True when GetAccountType reports the Administrator account type.
    isOrgAdministrator() {
      return this.normalizeAccountType(this.accounttype) === "administrator";
    },
    // True for clinical staff who get a patient-only home grid.
    isHealthcareProHomeGrid() {
      const t = this.normalizeAccountType(this.accounttype);
      return [
        "provider",
        "nurse",
        "registered nurse",
        "licensed practical nurse",
        "home health aid",
        "home health aids",
        "home health aide",
        "home health aides",
        "allied professional",
        "allied professionals",
        // GCM portal users get the patient-scoped HomeGrid (like Allied/Providers).
        "geriatric care manager",
        "geriatric care managers",
        "contact",
      ].includes(t);
    },
    // Whether welcome shows HomeGrid instead of health records.
    showHomeGrid() {
      return this.isOrgAdministrator || this.isHealthcareProHomeGrid;
    },
    // Tabs to render; admins see staff tabs only when the org group exists.
    visibleTabs() {
      const patientTab = {
        key: "Patient",
        label: "Patient Management",
        tabClass: "ordescriptab",
        id: "ordescripbtn",
      };
      if (!this.isOrgAdministrator) {
        return [patientTab];
      }
      const tabs = [patientTab];
      if (this.orgStaffGroups.providers) {
        tabs.push({
          key: "Provider",
          label: "Providers",
          tabClass: "medicationtab",
          id: "medicationbtn",
        });
      }
      if (this.orgStaffGroups.nurses) {
        tabs.push({
          key: "Nurse",
          label: "Nurses",
          tabClass: "diagnosistab",
          id: "diagnosisbtn",
        });
      }
      if (this.orgStaffGroups.aids) {
        tabs.push({
          key: "Aid",
          label: "Home Health Aid",
          tabClass: "proctab",
          id: "procbtn",
        });
      }
      if (this.orgStaffGroups.alliedPros) {
        tabs.push({
          key: "AlliedPro",
          label: "Allied Professionals",
          tabClass: "proctab",
          id: "alliedprobtn",
        });
      }
      // Last staff tab: Geriatric Care Managers.
      if (this.orgStaffGroups.gcm) {
        tabs.push({
          key: "GCM",
          label: "Geriatric Care Managers",
          tabClass: "proctab",
          id: "gcmbtn",
        });
      }
      return tabs;
    },
    // relations: function () {
    //   return getRelations(this.allData);
    // },
    // patientList: function () {
    //   // console.log(this.allData)
    //   if (this.filterList === null) return null;
    //   let that = this;
    //   let result = getFormattedRelationsList(this.allData);
    //   result = result.map((relation) =>
    //     _.extend(
    //       { active: !_.includes(that.filterList, relation.id) ? "Active" : "Invacive" },
    //       relation
    //     )
    //   );
    //   result.shift();
    //   if (this.filtered) {
    //     result = _.filter(
    //       result,
    //       (relation) => !_.includes(that.filterList, relation.id)
    //     );
    //   }
    //   let finalResult = result.filter((patient) => !patient.admin);
    //   return finalResult;
    // },
    // meters: function () {
    //   return getFormattedMeters(this.allData);
    // },
  },
  methods: {
    // ...mapActions("login", ["updateApplicationModel"]),
    // isActive(id) {
    //   return !(this.filterList && _.includes(this.filterList, id));
    // },
    // toggleStatus(id) {
    //   if (this.filtered) return;
    //   if (_.includes(this.filterList, id)) {
    //     let fi = _.indexOf(this.filterList, id);
    //     this.$delete(this.filterList, fi);
    //   } else {
    //     this.filterList.push(id);
    //   }
    //   this.preferences.provider_filter = this.filterList;
    //   updatePreferences(this.preferences);
    // },
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
    // Lowercase trim for account-type comparisons.
    //
    // The ported API returns `account_type` as a snake_case slug
    // (`registered_nurse`, `home_health_aid`), while the lists below are
    // written in the spaced English the legacy backend emitted. Folding
    // underscores to spaces makes both spellings compare equal; without it
    // every staff type except `provider` and `administrator` failed every
    // check and was handed the patient screen.
    normalizeAccountType(value) {
      return String(value || "")
        .trim()
        .toLowerCase()
        .replace(/_/g, " ");
    },
    // Lowercase trim for proto group name matching.
    normalizeGroupName(value) {
      return String(value || "")
        .trim()
        .toLowerCase();
    },
    // True if any candidate name matches an org group on the account.
    orgGroupExists(groups, candidates) {
      const names = new Set(
        (Array.isArray(groups) ? groups : []).map((g) =>
          this.normalizeGroupName(g?.name)
        )
      );
      return candidates.some((c) => names.has(this.normalizeGroupName(c)));
    },
    // Load account type and which org staff groups exist for tab visibility.
    async loadWelcomeGridMeta() {
      const accountnumber = this.allData?.patient?.externId2;
      const subaccountnumber = this.allData?.patient?.externId;
      if (!accountnumber) {
        this.accountMetaLoaded = true;
        return;
      }
      try {
        const typeRes = await axios.post(
          CURR_API + "/tswebhook.php",
          {
            Account: {
              API_Meth: "GetAccountType",
              accountnumber,
              subaccountnumber,
            },
          },
          { headers: { "Content-Type": "application/json;" } }
        );
        if (typeRes?.data?.providerAssignment?.accounttype) {
          this.accounttype = typeRes.data.providerAssignment.accounttype;
        }
        if (this.isOrgAdministrator) {
          const groupsRes = await axios.post(
            CURR_API + "/tswebhook.php",
            {
              Groups: {
                API_Meth: "GetGroupsByAccount",
                accountnumber,
              },
            },
            { headers: { "Content-Type": "application/json;" } }
          );
          const groups = Array.isArray(groupsRes?.data?.data)
            ? groupsRes.data.data
            : [];
          this.orgStaffGroups = {
            providers: this.orgGroupExists(groups, ["providers", "provider"]),
            nurses: this.orgGroupExists(groups, ["nurses", "nurse"]),
            aids: this.orgGroupExists(groups, [
              "home health aids",
              "home health aid",
              "home health aides",
              "home health aide",
            ]),
            alliedPros: this.orgGroupExists(groups, [
              "allied professionals",
              "allied professional",
            ]),
            // Enable GCM HomeGrid tab only when the org-level group exists.
            gcm: this.orgGroupExists(groups, [
              "geriatric care managers",
              "geriatric care manager",
            ]),
          };
        }
      } catch (e) {
        console.error("Failed to load welcome grid metadata:", e);
      } finally {
        this.accountMetaLoaded = true;
      }
    },
    // showNote(id, index) {
    //   let date = new Date();
    //   let tmpTime = date.toLocaleTimeString("en-US", { hour12: false }).slice(0, -3);
    //   this.noteTime = tmpTime.length == 7 ? `0${tmpTime}` : tmpTime;

    //   let note = document.getElementById("note__popup" + id);
    //   note.style.display = "flex";
    //   this.$refs.notePopup[index].startTimer();
    // },

    // async loadProviders() {
    //   let content = {
    //     NursyInfo: {
    //       API_Meth: "GetAccountNurse",
    //       accountnumber: this.allData.patient.externId2,
    //     },
    //   };
    //   await axios
    //     .post(CURR_API + "/tswebhook.php", content, {
    //       headers: { "Content-Type": "application/json;" },
    //     })
    //     .then((res) => {
    //       console.log(res);
    //       if (res.data) {
    //         this.allProvs = res.data.nurseInfo;
    //       } else {
    //         this.allProvs = null;
    //       }
    //     });
    // },
    // movingToNursePool(event) {
    //   console.log(event);

    //   console.log(this.nursesPL);
    //   let targetSourceItems = event.items;
    //   let insourcepmid = "";
    //   let nursename = "";
    //   for (var i = 0; i < event.items.length; i++) {
    //     nursename = targetSourceItems[i].firstname + " " + targetSourceItems[i].lastname;
    //     insourcepmid = targetSourceItems[i].pmid;
    //   }
    //   if (this.nursesPL[0].length > 0) {
    //     //filter the nursesPL

    //     for (var p = 0; p < this.nursesPL[0].length; p++) {
    //       if (
    //         this.nursesPL[0][p].firstname + " " + this.nursesPL[0][p].lastname ==
    //           nursename &&
    //         this.nursesPL[0][p].pmid == insourcepmid
    //       ) {
    //         // alert("Remove this one"+nursename);
    //         this.nursesPL[0].splice(p, 1);
    //       }
    //     }
    //     //console.log(this.nursesPL[0].filter((value,index) => this.nursesPL[0].indexOf(value) ==index));
    //     this.nursesPL[0].filter(
    //       (value, index) => this.nursesPL[0].indexOf(value) == index
    //     );

    //     //now loop through nursesPL and remove the item that matches nursename

    //     console.log(insourcepmid);
    //     console.log(nursename);
    //   }
    // },
    // async showOrder(id) {
    //   let content = {
    //     systemData: {
    //       API_Meth: "GetOrderNumber",
    //     },
    //   };
    //   await axios
    //     .post(CURR_API + "/tswebhook.php", content, {
    //       headers: { "Content-Type": "application/json;" },
    //     })
    //     .then((res) => {
    //       let num = res.data.ordernumber;
    //       if (num && num != "") {
    //         this.orderNum = num;
    //         let order = document.getElementById("order__popup" + id);
    //         order.style.display = "flex";
    //       } else
    //         alert(
    //           "Error generating order number. Contact an administrator before creating a new order."
    //         );
    //     });
    // },
    // async showNurseModule(id, id2, patientName) {
    //   console.log(this.allData.patient);
    //   console.log(id); //unique IDentifer
    //   console.log(id2); //account number
    //   //set Pateint Name
    //   this.PListPatientName = patientName;
    //   this.assignmentId = id;
    //   this.patId = id;
    //   this.accountId = id2;
    //   let content = {
    //     NursyInfo: {
    //       API_Meth: "GetAccountNurse",
    //       action: "GetNursesAssigned",
    //       patientid: id,
    //       accountnumber: id2, //this.allData.patient.externId2
    //     },
    //   };
    //   await axios
    //     .post(CURR_API + "/tswebhook.php", content, {
    //       headers: { "Content-Type": "application/json;" },
    //     })
    //     .then((res) => {
    //       console.log(res);
    //       this.nurses = res.data.nurseInfo;
    //       console.log(res.data);
    //       this.nursesPL = [res.data.nurseInfo, res.data.nurseassignmentInfo];
    //       if (this.nurses && this.nurses != "") {
    //         console.log(this.nurses);
    //       } else alert("Issue with paypack.");
    //     })
    //     .catch((res) => {
    //       console.log(res);
    //     });
    // },
    // //try to get nursePL second array items to find the id of the undefined
    // findPickListID(name) {
    //   console.log("Inside the find PickListID section");
    //   let spltname = name.split(" ");
    //   console.log(spltname);
    //   let fname = spltname[0];
    //   let lname = spltname[1];
    //   let nwar = this.nursesPL[1];
    //   let providerID = null;
    //   for (let t = 0; t < nwar.length; t++) {
    //     let constructname = fname + " " + lname;
    //     if (constructname == nwar[t].firstname + " " + nwar[t].lastname) {
    //       //lets get the id
    //       providerID = nwar[t].pmid;
    //       return providerID;
    //     }
    //   }
    // },
    // closeNurseAssigned() {
    //   this.assignmentId = null;
    // },
    // saveNurseAssigned(e, selectAr) {
    //   // alert("Button Clicked");
    //   e.preventDefault();
    //   console.log(selectAr);
    //   let nursetoassign = [];
    //   for (let i = 0; i < selectAr.length; i++) {
    //     let firstname = selectAr[i].firstname;
    //     let lastname = selectAr[i].lastname;
    //     let providerID = selectAr[i].providerID;
    //     /* if(providerID==undefined)
    //     {
    //       let providerID = this.findPickListID(firstname +" "+lastname);
    //       console.log(providerID +" "+"This is the nwe PID");
    //     }*/
    //     nursetoassign.push(providerID + "-" + firstname + " " + lastname);
    //   }
    //   // console.log(nursetoassign);

    //   this.AssignNurses(nursetoassign, this.patId, this.accountId);
    // },
    // async AssignNurses(nurseAr, pid, accntid) {
    //   let patientID = pid;
    //   let acntID = accntid;
    //   let content = {
    //     NursyInfo: {
    //       API_Meth: "AssigNurseToPatient",
    //       patientid: patientID,
    //       accountnumber: acntID,
    //       nurseInfo: nurseAr,
    //     },
    //   };
    //   await axios
    //     .post(CURR_API + "/tswebhook.php", content, {
    //       headers: { "Content-Type": "application/json;" },
    //     })
    //     .then((res) => {
    //       console.log(res);
    //       let message = res.data.message;
    //       if (message == "Nurse Assigned Successfully") {
    //         //lets check to see if they were assigned and/or discharged
    //         let msg = "Nurse(s):";
    //         if (res.data.nurseInfo.length > 0) {
    //           for (var t = 0; t < res.data.nurseInfo.length; t++) {
    //             msg += " " + res.data.nurseInfo[t] + ", ";
    //           }
    //           msg += "were assigned to the patient successfully!";
    //           alert(msg);
    //         } else if (res.data.dischargeInfo.length > 0) {
    //           msg += " THe following Nurse(s) were discharged from the patient:";
    //           for (var j = 0; j < res.data.dischargeInfo.length; j++) {
    //             console.log(res.data.dischargeInfo[j]);
    //             msg += " " + res.data.dischargeInfo[j] + ", ";
    //           }
    //           msg += "/n Thank You.";
    //           alert(msg);
    //         } else {
    //           alert("Data was updated, but please verify for your records");
    //         }

    //         provAssignmentById({
    //           assigned: res.data.nurseInfo.map((el) => el[1]),
    //           unassigned: res.data.dischargeInfo.map((el2) => el2[1]),
    //           patientId: patientID,
    //         }).then((resp) => {
    //           console.log(resp);
    //         });
    //       } else if (message == "Nurse(s) Already Assigned") {
    //         alert("Nurse(s) Already Assigned to the Patient");
    //       } else {
    //         alert(
    //           "Nurse Not Assigned Successfully,Please try again or contact your system Administrator"
    //         );
    //       }
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },
    // pageFactory(page, totalPages) {
    //   console.log("pageFactatory page=" + page + ",totalPages=" + totalPages);
    //   const pagination = {};
    //   pagination.from = this.itemsPerPage * (page - 1) + 1;
    //   pagination.to = Math.min(this.patientList.length, this.itemsPerPage * page);
    //   pagination.currentPage = page;
    //   pagination.total = this.patientList.length;
    //   pagination.totalPage = totalPages;

    //   this.$refs["pagination-info"].setPaginationData(pagination);
    //   this.$refs["pagination"].setPaginationData(pagination);
    // },
    // paginate(curPage) {
    //   if (this.patientList.length === 0) {
    //     this.$set(this, "patients", []);
    //     if (this.$refs["pagination-info"])
    //       this.$refs["pagination-info"].setPaginationData(null);
    //     if (this.$refs["pagination"]) this.$refs["pagination"].setPaginationData(null);
    //     return;
    //   }
    //   let tot = Math.ceil((this.patientList || []).length / this.itemsPerPage);
    //   if (curPage < tot) {
    //     this.$set(
    //       this,
    //       "patients",
    //       this.patientList.slice(
    //         this.itemsPerPage * (curPage - 1),
    //         this.itemsPerPage * curPage
    //       )
    //     );
    //     // this.patients = this.patientList.slice(this.itemsPerPage * (curPage - 1), this.itemsPerPage * curPage)
    //     this.pageFactory(curPage, tot);
    //   }
    //   if (curPage == tot) {
    //     this.$set(
    //       this,
    //       "patients",
    //       this.patientList.slice(this.itemsPerPage * (curPage - 1))
    //     );
    //     // this.patients = this.patientList.slice(this.itemsPerPage * (curPage - 1))
    //     this.pageFactory(curPage, tot);
    //   }
    // },
    // getPatientById(id) {
    //   console.log("Keyon Test ID" + " " + id);
    //   //return;
    //   try {
    //     let loader = this.$loading.show(
    //       {},
    //       {
    //         after: this.$createElement("div", {}, ["Switching accounts..."]),
    //       }
    //     );
    //     id = parseInt(id);
    //     enterPatientChart(id)
    //       .then(() => {
    //         window.location.hash = "null";
    //         window.location.reload();
    //       })
    //       .catch((e) => {
    //         console.log(e);
    //         setTimeout(() => {
    //           window.location.reload();
    //         }, 3000);
    //       });
    //   } catch (e) {
    //     console.log(e);
    //     setTimeout(() => {
    //       window.location.reload();
    //     }, 3000);
    //   }
    // },
    // share() {
    //   if (!this.shareId) {
    //     alert("Please enter a Patient ID # first");
    //     return;
    //   }
    //   let loader = this.$loading.show(
    //     {},
    //     {
    //       after: this.$createElement("div", {}, ["Sharing patient..."]),
    //     }
    //   );
    //   summaryByExternalId(this.shareId).then((res) => {
    //     if (res.data.error) {
    //       alert("Patient with ID " + this.shareId + " not found.");
    //       loader.hide();
    //       loader = null;
    //     } else {
    //       if (
    //         confirm(
    //           "Is the patient you are trying to share " +
    //             res.data.first +
    //             " " +
    //             res.data.last +
    //             " with date of birth " +
    //             res.data.dob +
    //             "?"
    //         )
    //       ) {
    //         acquireByExternalId(this.shareId).then((res2) => {
    //           if (res2.data.error) {
    //             alert(
    //               "This patient has already been shared. Please check your patient list."
    //             );
    //           } else {
    //             if (
    //               !alert(
    //                 "Patient " +
    //                   res.data.first +
    //                   " " +
    //                   res.data.last +
    //                   ", ID " +
    //                   this.shareId +
    //                   ", has been added to your patient list."
    //               )
    //             ) {
    //               window.location.reload();
    //             }
    //           }
    //         });
    //       }
    //       loader.hide();
    //       loader = null;
    //     }
    //   });
    // },
  }, //@import "../../../stylesheets/keyon";
};
</script>

<style scoped lang="scss">
@import "../../../stylesheets/mixins/flex";
$color-base: #0060ff;
$color-font: #58595b;

ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

p {
  margin: 0;
}

a {
  color: #000;
}

.quick-nav {
  // border: 1px solid lightgray;
  border-radius: 5px;
  margin: 2em auto;
  max-width: 1500px;
  text-align: center;
  // padding-bottom: 2em;
}

// .header {
//   text-align: center;
//   color: #fff;
//   font-size: 1.2em;
//   padding: 5px 0;
//   background-color: #007bff;
//   margin-bottom: 0px;
// }
.quick-nav__list {
  @include flex-box();
  margin: 40px 0;
}
.nurseBox-left {
  display: flex;
  flex-direction: column;
  width: 320px;
  height: auto;
  padding-bottom: 10px;
  border-color: #000000;
  border-style: solid;
  border-width: 1px;
}
.nurseBox-right {
  display: flex;
  flex-direction: column;
  width: 320px;
  height: auto;
  padding-bottom: 10px;
  border-color: #000000;
  border-style: solid;
  border-width: 1px;
}
.nursemodule {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  height: auto;
  align-items: stretch;
}
.nurse-items:hover {
  background-color: rgb(184, 245, 196);
}
.quick-nav__item {
  @include flex(1, 0, 45%);
  width: 350px;
  padding: 0 20px;
}
.picklist-close-save {
  display: flex;
  width: 100%;
  flex-direction: row-reverse;
  padding-right: 82px;
  padding-top: 20px;
}
.item__subtitle {
  padding: 5px 0;
  font-weight: bold;
}

.item__explanation {
  color: gray;
  font-size: 0.9em;
}

.item__link {
  display: block;
  width: 100%;
  // background-color: #007bff;
  color: #fff;
  font-size: 0.8em;
  border-radius: 3px;
  padding: 5px 0;
  margin-top: 10px;
}

.item__link__group {
  display: flex;
}

.existing__link {
  width: 50%;
  border: none;
}

#add__externId {
  color: black;
  background-color: white;
  width: 45%;
  margin-right: 20px;
  text-align: center;
}

.icon {
  font-size: 2em;
}

.loader {
  margin: 0 auto;
  border: 5px solid #f3f3f3;
  /* Light grey */
  border-top: 5px solid #3498db;
  /* Blue */
  border-radius: 50%;
  width: 35px;
  height: 35px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@media only screen and (max-width: 768px) {
  .quick-nav {
    margin-bottom: 0;
  }

  .quick-nav__list {
    flex-direction: column;
  }

  .quick-nav__item {
    @include flex(1, 1, auto);
    width: 100%;
    padding: 0 20px;

    &:first-child {
      margin-bottom: 20px;
    }
  }
}

.sharePatientBtn {
  background-color: #165891;
  color: #ffffff;
  font-size: 18px;
  text-align: center;
  width: 220px;
}

.patientStatus:not(.filtered) {
  border: 1px solid rgba(0, 0, 0, 0.3);
}

.patientStatus:not(.filtered):hover {
  border: 1px solid rgba(0, 0, 0, 0.5);
  background-color: rgb(204, 204, 255);
}

.patientStatus:not(.filtered):not(.active) {
  box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.7);
  margin-top: 2px;
}

#patientStatus:not(.filtered).active {
  margin-top: 5px;
}

#patientExtern,
#patientName {
  color: blue;
  cursor: pointer;
  text-decoration: underline;
}
/*Adding Styles for Provider Card here */
.header3 {
  text-align: center;
  color: #fff;
  font-size: 1.2em;
  padding: 5px 0;
  background-color: #007bff;
}
.status-nonactive {
  display: none;
  background-color: #f12f4f;
  color: #ffffff;
  font-size: 17px;
}
.status-active {
  display: none;
  background-color: #70a50d;
  color: #ffffff;
  font-size: 17px;
}
.result-list {
  width: 700px;
}
.result-item-link {
  display: block;
  text-align: right;
  font-size: 0.85em;
}

ul {
  list-style-type: none;
  margin: 0 auto;
}
#nursetype {
  margin-bottom: 10px;
}
.provcardSec {
  display: none;
  align-items: center;
  position: relative;
  flex-direction: column;
}
.emailcanvas {
  display: none;
}

#cllprov {
  margin-left: 20px;
}
#providetomail {
  margin-left: 30px;
}
#provemailsubject {
  margin-left: 30px;
}
#provid-emailmsg {
  margin-left: 30px;
  margin-top: -10px;
  margin-bottom: 10px;
  width: 400px;
  height: 100px;
}
#sendprovid-emailbtn {
  margin-left: 30px;
}
.emailcanvas .container {
  box-shadow: 1px 1px 9px #5f5852;
  position: absolute;
  background-color: #ffffff;
  width: 855px;
  height: auto; // 710px;
  padding-bottom: 20px;
  margin: 0 auto;
}
.emailcanvas .btn-container {
  padding-bottom: 30px;
}
.emailcanvas label {
  margin-bottom: 20px;
}
#providetomail {
  margin-left: 30px;
}
.emailcanvas ul {
  display: flex;
  margin-top: -64px;
}
.emailcanvas .emailli {
  list-style: none;
  margin-left: 20px;
}
.emailcanvas .emailblock {
  background-color: #aaabac;
  padding: 5px 5px;
  width: auto;
  height: auto;
  margin-left: 12px;
  position: relative;
  top: 17px;
}
.emailcanvas .xout {
  background-color: white;
  cursor: pointer;
}
.mmailbox {
  background-color: #55555512;
  width: 100%;
  position: relative;
  z-index: 3000000000;
  top: -35px;
}
.mmailbox #hiddenmail {
  display: none;
}
.emailcanvas .selectbox {
  margin-top: -10px;
}
.inputvalholder {
  display: none;
  justify-content: flex-start;
}
.p-picklist {
  width: 75%;
  position: relative;
  top: -400px;
  background-color: #5d6262;
  margin: 0 auto;
  border-style: solid;
  border-width: 2px;
}
.p-picklist-buttons {
  background-color: #000000;
}
body .p-picklist .p-picklist-header {
  background: #546cc3;
  color: #ffffff;
}
body .p-picklist .p-picklist-list .p-picklist-item {
  background: #fff;
  color: #000;
}
.p-picklist-buttons .p-button {
  background: #000000;
  border-color: #ffffff;
  color: #ffffff;
}
.picklist-close-save {
  position: relative;
  top: -400px;
  padding-right: 172px;
}

.mobile-form-section {
  border-radius: 8px;
  padding: 15px;
}

.mobile-form-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

.mobile-form-group :deep(.canvas) {
  margin-top: 1.25rem;
}

.mobile-form-btn {
  border: none;
  padding: 15px;
  margin: 2px 0;
  font-size: 16px;
  border-radius: 0;
  cursor: pointer;
  text-align: left;
}

.tab-link:hover {
  background-color: #3371b7;
}

.tab-link.active {
  background-color: #3371b7;
}

.tab-content {
  padding: 20px;
  border: 1px solid #ccc;
  border-top: none;
}

.assignments {
  color: blue;
  cursor: pointer;
  text-decoration: underline;
}

/* Mobile-specific z-index adjustments for mobile message widget */
@media (max-width: 768px) {
  .mmailbox {
    z-index: 1 !important;
  }
  
  /* Ensure all high z-index elements stay below mobile widget */
  [style*="z-index"] {
    z-index: 1 !important;
  }
}
</style>
